import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import LummusModelEditDto from '../dto/LummusModelEditDto';

class LummusModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'lummusModelEditControl';
	}

	/**
	 * @param {string} driverName
	 * @return {Promise<LummusModelEditDto>}
	 */
	create(driverName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/create`, { driverName })
				.then(response => resolve(new LummusModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<LummusModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new LummusModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {LummusModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {LummusModelEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new LummusModelEditService();
